import { render, staticRenderFns } from "./NonDelivery.vue?vue&type=template&id=ed46bea0&"
import script from "./NonDelivery.vue?vue&type=script&lang=js&"
export * from "./NonDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports